import { render, staticRenderFns } from "./legal-banking.vue?vue&type=template&id=355b9c9d&scoped=true"
import script from "./legal-banking.vue?vue&type=script&lang=js"
export * from "./legal-banking.vue?vue&type=script&lang=js"
import style0 from "./legal-banking.vue?vue&type=style&index=0&id=355b9c9d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355b9c9d",
  null
  
)

export default component.exports